import React from "react";
import defaultAvatar from "../assets/avatar.png";
import MenuIcon from "../assets/menu.png";

const Navbar: React.FC = () => {
  return (
    <div className="flex fixed z-10 px-4 md:px-10 py-2 items-center bg-white w-full shadow">
      <button type="button" className="outline-none">
        <img src={MenuIcon} alt="Menu" width={50} height={50} />
      </button>

      <div className="ml-auto flex items-center gap-x-3">
        <img src={defaultAvatar} alt="Avatar" width={40} height={40} />
        <h6>Jaden Miles</h6>
      </div>
    </div>
  );
};

export default Navbar;
